/**
 * @ignore
 */
export const cropOptions = [
  /* { value: null, description: 'user.selectCropType' },*/
  { value: 'full', description: 'user.fullCrop' },
  { value: 'half', description: 'user.halfCrop' },
  { value: 'halfBlur', description: 'user.halfBlurCrop' },
  { value: 'blur', description: 'user.blurCrop' },
];
/**
 * @ignore
 */
export const interiorCropOptions = [
  { value: null, description: 'user.selectCropInteriorType' },
  { value: 'full', description: 'user.fullCrop' },
  { value: 'blur', description: 'user.blurCrop' },
];
/**
 * @ignore
 */
export const bgTypeOptions = [
  /* { value: null, description: 'user.bgType' },*/
  { value: 'box', description: 'user.photoBox' },
  { value: 'flat', description: 'user.basic' },
  { value: 'platform', description: 'user.platform' },
  { value: 'elevation', description: 'user.3D' },
];
/**
 * @ignore
 */
export const logoPositionOptions = [
  { value: null, description: 'user.selectLogoPosition' },
  { value: 'auto', description: 'user.auto' },
  { value: 'topLeft', description: 'user.topLeft' },
  { value: 'bottomLeft', description: 'user.bottomLeft' },
  { value: 'topRight', description: 'user.topRight' },
  { value: 'bottomRight', description: 'user.bottomRight' },
];
/**
 * @ignore
 */
export const blurOptions = [
  { value: '0', description: 'user.blurAmount' },
  { value: '4', description: 'user.smallBlur' },
  { value: '8', description: 'user.mediumBlur' },
  { value: '12', description: 'user.highBlur' },
  { value: '16', description: 'user.ultraHighBlur' },
  { value: '24', description: 'user.extremeBlur' },
];
/**
 * @ignore
 */
export const cameraLibelaSensitivity = [
  { value: undefined, description: 'Select Sensitivity' },
  { value: 'off', description: 'OFF' },
  { value: 'low', description: 'Low' },
  { value: 'medium', description: 'Medium' },
  { value: 'high', description: 'High' },
];
/**
 * @ignore
 */
export const shadowType = [
  { value: null, description: 'Select shadow type' },
  { value: 'default', description: 'Default' },
  { value: 'ai', description: 'AI' },
  { value: 'legacy', description: 'Legacy' },
];

export const featuresWhiteIcons = [
  {
    name: 'licensePlateImage',
    icon: '/assets/img/plates-icon-white.svg',
  },
  {
    name: 'reflectiveFloor',
    icon: '/assets/img/reflection-icon-white.svg',
  },
  {
    name: 'cutting',
    icon: '/assets/img/crop-car-icon-white.svg',
  },
  {
    name: 'polishing',
    icon: '/assets/img/car-paint-icon-white.svg',
  },
  {
    name: 'rimPolishing',
    icon: '/assets/img/rim-icon-white.svg',
  },
  {
    name: 'licensePlateBlur',
    icon: '/assets/img/plates-blur-white.svg',
  },
  {
    name: 'flipImage',
    icon: '/assets/img/flip-icon-white.svg',
  },
  {
    name: 'platform_360',
    icon: '/assets/img/360-white.svg',
  },
  {
    name: 'removeReflections',
    icon: '/assets/img/removeReflections-white.svg',
  },
  {
    name: 'refectiveFloorFull',
    icon: '/assets/img/car-reflection-white.svg',
  },
  {
    name: 'panorama_front',
    icon: '/assets/img/panorama-front-white.svg',
  },
  {
    name: 'panorama_back',
    icon: '/assets/img/panorama-back-white.svg',
  },
  {
    name: 'markers',
    icon: '/assets/img/marker_icon.svg',
  },
  {
    name: 'carconfImport',
    icon: '/assets/img/car-confi-import-white.svg',
  },
  {
    name: 'instagram',
    icon: '/assets/img/instagram-white.svg',
  },
  {
    name: 'instagramCatch',
    icon: '/assets/img/instagram-catch-white.svg',
  },
  {
    name: 'pro',
    icon: '/assets/img/pro-icon.svg',
  },
  {
    name: 'premium360',
    icon: '/assets/img/360-video.svg',
  },
  {
    name: 'premiumVideo',
    icon: '/assets/img/image-video.svg',
  },
];
